import axios from "axios";
import authHeader from "./auth-header";
import { baseURL } from "../constants";

class ExportBuilderService {
  getColumns() {
    return axios.get(baseURL + "/export-builder/columns", {
      headers: authHeader()
    });
  }

  preview(columns, filters) {
    return axios.post(
      baseURL + "/export-builder/preview",
      { columns: columns, tahun: filters.tahun, id_fakultas: filters.id_fakultas, id_prodi: filters.id_prodi, status_lulusan: filters.status_lulusan },
      { headers: authHeader() }
    );
  }

  build(columns, filters) {
    return axios.post(
      baseURL + "/export-builder/build",
      { columns: columns, tahun: filters.tahun, id_fakultas: filters.id_fakultas, id_prodi: filters.id_prodi, status_lulusan: filters.status_lulusan },
      { headers: authHeader(), responseType: "blob" }
    );
  }

  getPresets() {
    return axios.get(baseURL + "/export-builder/presets", {
      headers: authHeader()
    });
  }

  savePreset(name, description, columns, filters) {
    return axios.post(
      baseURL + "/export-builder/presets",
      { name: name, description: description, columns: columns, filters: filters },
      { headers: authHeader() }
    );
  }

  deletePreset(id) {
    return axios.delete(baseURL + "/export-builder/presets/" + id, {
      headers: authHeader()
    });
  }
}

export default new ExportBuilderService();
